import { ADMIN_FAQ_LIST } from './index';
import { Action } from '../action';
import { FaqInfo } from '@shared/core';

export class AdminFaqListInitAction implements Action {
	readonly type = ADMIN_FAQ_LIST.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqListDestroyAction implements Action {
	readonly type = ADMIN_FAQ_LIST.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqListClickAddAction implements Action {
	readonly type = ADMIN_FAQ_LIST.CLICK_ADD;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqListClickShowGroupAction implements Action {
	readonly type = ADMIN_FAQ_LIST.CLICK_SHOW_GROUP;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqListClickAddGroupAction implements Action {
	readonly type = ADMIN_FAQ_LIST.CLICK_ADD_GROUP;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqListClickEditAction implements Action {
	readonly type = ADMIN_FAQ_LIST.CLICK_EDIT;
	constructor(
		public payload: FaqInfo,
		public correlationId?: number
	) {}
}

export class AdminFaqListClickDeleteAction implements Action {
	readonly type = ADMIN_FAQ_LIST.CLICK_DELETE;
	constructor(
		public payload: FaqInfo,
		public correlationId?: number
	) {}
}

export class AdminFaqListClickDeleteSuccessAction implements Action {
	readonly type = ADMIN_FAQ_LIST.CLICK_DELETE_SUCCESS;
	constructor(
		public payload: FaqInfo,
		public correlationId?: number
	) {}
}

export class AdminFaqListClickDeleteFailureAction implements Action {
	readonly type = ADMIN_FAQ_LIST.CLICK_DELETE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminFaqListHydrateAction implements Action {
	readonly type = ADMIN_FAQ_LIST.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqListHydrateSuccessAction implements Action {
	readonly type = ADMIN_FAQ_LIST.HYDRATE_SUCCESS;
	constructor(
		public payload: FaqInfo[],
		public correlationId?: number
	) {}
}

export class AdminFaqListHydrateFailureAction implements Action {
	readonly type = ADMIN_FAQ_LIST.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
